import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import '../../lib/LodashMixins';

export default function CheckboxInput(props) {
    const [isMounted, setIsMounted] = useState(false);
    const [value, setValue] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [noWrapper, setNoWrapper] = useState(false);

    const checkboxClickHandler = (id, _event) => {
        if (!props.disabled) {
            setValue(!_.stringToBoolean(value));
            if (props.changed) { props.changed(id, value); }
        }
    };

    useEffect(() => {
        setHasError(!_.isEmpty(props.errorMessage));
    }, [props.errorMessage]);

    useEffect(() => {
        setValue(_.stringToBoolean(props.value));
    }, [props.value]);

    useEffect(() => {
        if (isMounted) { return; }
        setValue(_.stringToBoolean(props.value));
        if (props.noWrapper) {
            setNoWrapper(_.stringToBoolean(props.noWrapper));
        }

        setIsMounted(true);
    }, [isMounted, props]);

    const classChecked = (value) ? 'form-checkbox-checked' : '';
    const classType = (hasError) ? 'form-checkbox-error' : '';
    const wrapperStyle = noWrapper ? { display: 'inline' } : { paddingBottom: '2px', display: 'flex', alignItems: 'center' };

    return <div className='custom-checkbox-input' style={wrapperStyle} onClick={(event) => checkboxClickHandler(props.id, event)}>
        <label
            className={`form-checkbox ${classType} ${classChecked}`}
            disabled={props.disabled}>
            <input id={props.id} type="hidden" value={value} />
            <span className="glyphicon glyphicon-ok" style={{ opacity: (value ? 1 : 0) }}></span>
        </label>
        <span style={{ marginLeft: '7px', fontWeight: 'bold', cursor: 'default' }}>{props.labelText}</span>
    </div>
}
